/**
 * Created by hp on 2017/8/10.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';

class MainCacheData extends Component {
    constructor() {
        super();
        this.handleSetCacheData = this.handleSetCacheData.bind(this);
        this.handleGetCacheData = this.handleGetCacheData.bind(this);
        this.handleSetCacheTop = this.handleSetCacheTop.bind(this);
        this.handleGetCacheTop = this.handleGetCacheTop.bind(this);
        this.handleHasCacheData = this.handleHasCacheData.bind(this);
        this.handleSetCacheCategory = this.handleSetCacheCategory.bind(this);
        this.handleGetCacheCategory = this.handleGetCacheCategory.bind(this);
        this.handleSetCachePage = this.handleSetCachePage.bind(this);
        this.handleGetCachePage = this.handleGetCachePage.bind(this);
        this.handleScroll = this.handleScroll.bind(this);

        this.CACHE_DATA_KEY = 'newWkIndexMixBoxData';
        this.CACHE_TOP_KEY = 'newWkIndexScrollTop';
        this.CACHE_SELECTED_CATEGORY_KEY = 'newSelectedCategory';
        this.CACHE_PAGE_KEY = 'newPage';
    }

    componentDidMount() {
        this.handleGetCacheData();
        this.handleGetCacheTop();

        window.addEventListener('scroll', this.handleScroll);

        // 刷新或离开当前页面，记录当前位置
        window.onbeforeunload = () => {
            this.handleSetCacheTop(true);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        let documentHeight = document.body.scrollHeight || document.documentElement.scrollHeight;
        let topOffset = document.body.scrollTop || document.documentElement.scrollTop;
        let windowHeight = document.documentElement.clientHeight;

        if ((documentHeight - windowHeight - topOffset) <= 0) {
            let cacheData = this.handleHasCacheData();
            if (cacheData) {
                this.props.dispatch({type: 'MAIN_CACHE_PAGE', payload: parseInt(cacheData.p, 10)});
            } else {
                this.props.dispatch({type: 'MAIN_NEXT_PAGE'});
            }
            this.context.mainPage.loadMoreData();
        }

        if (topOffset >= 44) {
            if(!this.props.isTabFixTop)
                this.props.dispatch({type: 'MAIN_SET_CATEGORY_TOP'});
        } else {
            if(this.props.isTabFixTop)
                this.props.dispatch({type: 'MAIN_UNSET_CATEGORY_TOP'});
        }
    }

    componentDidUpdate() {
        this.handleSetCacheData();
        this.handleSetCacheCategory();
    }

    handleSetCachePage(page) {
        sessionStorage.setItem(this.CACHE_PAGE_KEY, page);
    }

    handleGetCachePage() {
        return sessionStorage.getItem(this.CACHE_PAGE_KEY);
    }

    handleSetCacheCategory() {
        const {selectCategory} = this.props;
        sessionStorage.setItem(this.CACHE_SELECTED_CATEGORY_KEY, selectCategory);
    }

    handleGetCacheCategory() {
        return sessionStorage.getItem(this.CACHE_SELECTED_CATEGORY_KEY);
    }

    handleHasCacheData() {
        return JSON.parse(sessionStorage.getItem(this.CACHE_DATA_KEY));
    }

    handleSetCacheData() {
        const {cacheData} = this.props;

        if (cacheData) {
            let data = {ret: cacheData.data, has_more: cacheData.hasMore};
            sessionStorage.setItem(this.CACHE_DATA_KEY, JSON.stringify({
                mixBoxData: data,
                p: cacheData.page,
                categoryId: cacheData.categoryId,
            }));

            this.handleSetCachePage(cacheData.page);
        } else {
            sessionStorage.removeItem(this.CACHE_DATA_KEY);
            this.handleSetCachePage(1);
        }
    }

    handleGetCacheData() {
        let sessionCacheData = JSON.parse(sessionStorage.getItem(this.CACHE_DATA_KEY));

        if (sessionCacheData) {
            this.props.dispatch({
                type: 'MAIN_SET_RECOMMEND_CACHE',
                payload: {
                    ret: sessionCacheData.mixBoxData.ret,
                    hasMore: sessionCacheData.mixBoxData.has_more,
                }
            });
        }
    }

    handleSetCacheTop(isRefresh) {
        const {cacheData} = this.props;
        if (cacheData) {
            sessionStorage.setItem(this.CACHE_TOP_KEY, JSON.stringify({
                scrollTop: cacheData.top
            }));
        }

        if (isRefresh) {
            sessionStorage.setItem(this.CACHE_TOP_KEY, JSON.stringify({
                scrollTop: document.body.scrollTop
            }));
        }
    }

    handleGetCacheTop() {
        const {page} = this.props;
        let cacheTop = sessionStorage.getItem(this.CACHE_TOP_KEY);

        if (cacheTop) {
            cacheTop = JSON.parse(cacheTop);
            let scrollTop = 0;
            if (!(cacheTop.scrollTop === 0 && page === 1)) {
                scrollTop = document.body.scrollTop > cacheTop.scrollTop ? document.body.scrollTop : cacheTop.scrollTop;
            }

            setTimeout(() => {document.body.scrollTop = scrollTop;}, 100);
        }
    }

    render() {
        return null;
    }
}

MainCacheData.contextTypes = {
    mainPage: React.PropTypes.object
};

export default connect((state) => ({
    cacheData: state.main.cacheData,
    page: state.main.page,
    isTabFixTop: state.main.isTabFixTop,
    selectCategory: state.main.selectCategory,
}))(MainCacheData)



// WEBPACK FOOTER //
// ./src/components/main/MainCacheData.js